export const styleTable = {
    display: 'flex',
    height: "96%",
    marginBottom: "0",
    paddingBottom: "0",
    alingItems: 'center',
    flexDirection: 'column'
}